import React, { Component } from "react";
import M from "materialize-css";

import { Player } from "video-react";
import "../../node_modules/video-react/dist/video-react.css";

import $ from "jquery";

class ModalVideo extends Component {
  constructor(props) {
    super(props);

    this.state = { mostrarIframe: true }; //lo pase a true
    //console.log(this.state.mostrarIframe, "mostrarIframe");
  }

  componentDidMount() {
    const options = {
      onOpenStart: () => {
        if (this.player) {
          this.player.play();
        }
      },

      onCloseEnd: () => {
        if (this.player) {
          this.player.pause();
          this.player.seek(0);
        } else {
          //this.setState({ mostrarIframe: false });
          //$("iframe").remove();
          //-----------------------------------------------------
          //posible solucion
          /* $(‘.modal’).on(‘hidden.bs.modal’, function () {
          var $this = $(this);
          //get iframe on click
          var vidsrc_frame = $this.find(“iframe”);
          var vidsrc_src = vidsrc_frame.attr(‘src’);
          console.log(`videosrc=` + vidsrc_src)
          vidsrc_frame.attr(‘src’, ‘’);
          vidsrc_frame.attr(‘src’, vidsrc_src);
          }); */
          this.props.handleMostrarModal(false);
        }
      },

      inDuration: 250,
      outDuration: 250,
      dismissible: true,
    };

    var instanciaDelModal = M.Modal.init(this.Modal, options);

    if (!localStorage.getItem("yavistioelsitio")) {
      //this.setState({ mostrarIframe: true });
      instanciaDelModal.open();
    }
  }

  render() {
    return (
      <div>
        <div
          ref={(Modal) => {
            this.Modal = Modal;
          }}
          id="modal-video"
          className="modal"
          style={{ width: "75%", height: "100%" }}
        >
          <div
            className="modal-content valign-wrapper"
            style={{
              width: "80%",
              height: "100%",
              padding: "1%",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            {this.state.mostrarIframe && (
              <div
                className="center-align"
                style={{ width: "100%", height: "100%" }}
              >
                <iframe
                  style={{ margin: "0", padding: "0", width: "100%" }}
                  id="iframe"
                  src="https://www.youtube.com/embed/xRzHyWDWTe0"
                  frameborder="0"
                  //allow="autoplay"
                  width="100%"
                  height="100%"
                  tittle="video"
                ></iframe>
              </div>
            )}

            {/*   {!this.state.mostrarIframe && (
              <Player
                ref={(player) => {
                  this.player = player;
                }}
                src="videos/PranaVideo2.mp4"
              />
            )} */}
          </div>
        </div>
      </div>
    );
  }
}

export default ModalVideo;
